import script from "./AuthSetup.vue?vue&type=script&lang=js"
export * from "./AuthSetup.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__